import React, { FC } from 'react';
import { CloseCross, InformationStroke } from '../../atoms/icons';
import { Drawer } from '../../molecules/drawer/Drawer';
import { NoStoresError } from '../storeLocator/NoStoresError';
import FindStoreForm from './FindStoreForm';
import StoreListItem from './StoreListItem';
import Notification from '../../atoms/notification';
import PrimaryLoader from '../../atoms/primaryLoader/PrimaryLoader';
import { useFindStore } from '@srcDS/hooks/useFindStore';
import { buttonCloseSize, stylesDrawer } from './options';
import { FindStoreDrawerProps } from '@srcDS/components/organisms/findStoreDrawer/types';

import styles from './FindStoreDrawer.module.scss';

const FindStoreDrawer: FC<FindStoreDrawerProps> = ({
  showDrawer,
  setShowDrawer,
  sizeOptions,
  selectedSize,
  handleSetSelectedStore,
  register,
  onChangeVariant,
  setActiveOption,
  activeOptions,
  selectVariant,
  isSelectingSize,
  selectedStore,
  setValue,
  shouldHideClickCollect,
}) => {
  const {
    emptyError,
    loadingStores,
    locationError,
    postCodeValue,
    hasAnyProductInCart,
    filteredStores,
    isMobile,
    loading,
    preferredPostcode,
    getUserPosition,
    handleChangeVariant,
    handleGetStoreList,
    setLocationError,
    setFilteredStores,
  } = useFindStore({
    isNewVersionOfFindStore: true,
    showDrawer,
    selectedStore,
    selectedSize,
    activeOptions,
    onChangeVariant,
  });

  return (
    <div>
      {showDrawer && (
        /*@ts-ignore*/
        <Drawer
          showHeader={false}
          onClose={() => setShowDrawer(false)}
          shown={showDrawer}
          width={isMobile ? null : 497}
          position="right"
          customClasses={stylesDrawer}
        >
          <div className={styles.container}>
            <div className={styles.closeButtonWrapper} onClick={() => setShowDrawer(false)}>
              {/*@ts-ignore*/}
              <CloseCross colour="#000" {...buttonCloseSize} />
            </div>
            <h2 className={styles.title}>Find in store</h2>
            <p className={styles.desc}>Please enter your postcode to view store availability.</p>
            <FindStoreForm
              loading={loading}
              preferredPostcode={preferredPostcode}
              getUserPosition={getUserPosition}
              selectedSize={selectedSize}
              sizeOptions={sizeOptions}
              onSubmitAction={handleGetStoreList}
              sizeRegister={register}
              onChangeVariant={handleChangeVariant}
              setActiveOption={setActiveOption}
              isSelectingSize={isSelectingSize}
              selectVariant={selectVariant}
              setFilteredStores={setFilteredStores}
              setLocationError={setLocationError}
              setSizeValue={setValue}
              isMobile={isMobile}
            />
            {loadingStores && (
              <div className={styles.loadingWrapper}>
                <div className={styles.loader}>
                  <PrimaryLoader mode="segment" size={40} />
                </div>
              </div>
            )}

            {hasAnyProductInCart && (
              <div className={styles.informMessage}>
                <InformationStroke />
                <p>All items in cart will be updated to latest store selected</p>
              </div>
            )}

            <div>
              {filteredStores.length
                ? filteredStores.map((store) => (
                    <StoreListItem
                      store={store}
                      key={store.id}
                      skuId={activeOptions?.sku}
                      selectedStore={selectedStore}
                      setShowDrawer={setShowDrawer}
                      setSelectedStore={handleSetSelectedStore}
                      shouldHideClickCollect={shouldHideClickCollect}
                    />
                  ))
                : null}
              {!filteredStores.length && emptyError && postCodeValue && !loadingStores ? (
                <NoStoresError postCode={postCodeValue} hideViewAll />
              ) : null}
              {locationError && !loadingStores && <Notification type="error" message={locationError} />}
            </div>
          </div>
        </Drawer>
      )}
    </div>
  );
};

export default FindStoreDrawer;
